// extracted by mini-css-extract-plugin
module.exports = {"envVars":"style_envVars__2fD7b","sensitiveWrap":"style_sensitiveWrap__DXANi","sensitiveIcon":"style_sensitiveIcon__16o-8"};